import { FC } from 'react'

import { R } from 'core/helpers'

import { BoxContent, ErrorBox, ErrorMessage, ErrorTitle, FallbackProps } from './defaultErrorBoundaries'
import ErrorRecoveryActions from './ErrorRecoveryActions'

const DefaultErrorFallback: FC<FallbackProps> = ({ className, error, reset }) => (
  <ErrorBox $type={R.isObject(error) && error.status === 403 ? 'warning' : 'error'} className={className}>
    <ErrorTitle>Something went wrong</ErrorTitle>
    <BoxContent>
      <ErrorMessage error={error} />
    </BoxContent>
    <ErrorRecoveryActions onRetry={reset} />
  </ErrorBox>
)

export default DefaultErrorFallback
